import { useEffect } from 'react';
import { Room } from 'twilio-video';

import { isIOS16 } from 'features/video-conference/utils/ios15Workaround';
import { captureException } from 'shared/utils/handlerErrors';

export function useIOS16MediaRefresh(room: Room | null): void {
  useEffect(() => {
    if (!room || !isIOS16()) return () => null;

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        try {
          room.refreshInactiveMedia();
        } catch (error) {
          captureException(error);
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [room]);
}
